import {authModule} from './../store/modules/auth';
import {Component, Vue} from 'vue-property-decorator';
import dayjs from 'dayjs';
import {User} from '@/store/modules/users';

@Component
export default class PasswordMixin extends Vue {
  @authModule.State('user') user!: User;

  get userPassword() {
    return this.user?.passwordDateChanges;
  }

  get differentDatePassword() {
    const today = dayjs(new Date());
    const userPasswordDate = dayjs(this.userPassword);
    return today.diff(userPasswordDate, 'day');
  }
}
